import api from "./axiosInstance";
import apiRoutes from "./api_route";

export const login = async (credentials) => {
  const response = await api.post(apiRoutes.auth.login, credentials);
  return response.data;
};

export const sendPhoneOtp = async (phone) => {
  const response = await api.post(apiRoutes.auth.sendOtp, { phone });
  return response.data;
};

export const verifyPhoneOtp = async ({ phone, otp }) => {
  const response = await api.post(apiRoutes.auth.verifyOtp, { phone, otp });
  return response.data;
};

export const fetchMyCases = async () => {
  const response = await api.get(apiRoutes.cases.myCases);
  return response.data;
};
